export default __webpack_public_path__ + "static/media/rental.fadf4ebe.svg";